<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Excel Manager</h1>
            </div>
            <div class="dropdown-container" style="display: flex; align-items: center;">
                <p-dropdown [options]="fileList" [(ngModel)]="selectedFile" placeholder="Select a file"
                    (onChange)="onFileSelect($event)">
                </p-dropdown>
            </div>

            <div class="table-container" *ngIf="selectedFile">
                <!-- <div class="filename-section">
                    <label for="filename" class="mr-2">Filename: </label>
                    <input type="text" [(ngModel)]="filename" [disabled]="!isFilenameEditMode" class="filename-input"
                        id="filename" />

                    <button pButton [label]="isFilenameEditMode ? 'Save' : 'Edit'" (click)="toggleFilenameEditMode()"
                        class="filename-edit-button">
                    </button>
                </div> -->
                <!-- Usage Section -->
                <div class="usage-section">
                    <label for="usage" class="mr-2">Usage : </label>
                    <input type="text" [(ngModel)]="usage" [disabled]="!usage_editable || !isUsageEditMode"
                        class="usage-input" id="usage" />

                    <!-- Usage Edit/Save Button -->
                    <button pButton [label]="isUsageEditMode ? 'Save' : 'Edit'" (click)="toggleUsageEditMode()"
                        [disabled]="!usage_editable" class="usage-edit-button">
                    </button>
                </div>

                <!-- Table Section -->
                <div>
                    <button *ngIf="filename!=='Latest_Unique_Company_Names'" pButton
                        [label]="isEditMode ? 'Save' : 'Edit'" (click)="toggleEditMode()" [disabled]="!value_editable"
                        class="edit-button my-2">
                    </button>

                    <!-- <button pButton [label]="isEditMode ? 'Save' : 'Edit'" (click)="toggleEditMode()"
                        class="edit-button my-2">
                    </button> -->

                    <!-- Dynamic Table -->
                    <p-table #filedata [value]="fileFilterData" [paginator]="true" [rows]="10"
                        [totalRecords]="totalRecords" [lazy]="true" [rowsPerPageOptions]="[10, 50, 100]"
                        [loading]="loading" (onLazyLoad)="loadFiles($event)" responsiveLayout="scroll"
                        [globalFilterFields]="globalFilterFields"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                        <ng-template pTemplate="caption">
                            <div class="flex" style="display: flex; justify-content: space-between;">
                                <div>
                                    <div class="d-flex align-items-center">
                                        <button pButton type="button" label="Download Excel" icon="pi pi-file-excel"
                                            class="p-button-success" style="margin: 0px 10px 0px 10px;"
                                            (click)="downloadExcel()">
                                        </button>
                                        <div *ngIf="isValidFile()" class="file-upload-container"
                                            style="display: flex; align-items: center; gap: 10px;">
                                            <!-- Button to trigger file selection -->
                                            <button pButton type="button" label="Select Excel File"
                                                icon="pi pi-file-excel" class="p-button-secondary"
                                                (click)="fileInput.click()">
                                            </button>

                                            <!-- Hidden input for file selection -->
                                            <input type="file" #fileInput (change)="handleFileSelection($event)"
                                                accept=".xlsx, .xls, .csv" style="display: none;" />

                                            <!-- Display selected file name -->
                                            <span *ngIf="selectedExcelFile">{{ selectedExcelFile.name }}</span>

                                            <!-- Button to upload the selected file -->
                                            <button pButton type="button" label="Upload File" icon="pi pi-upload"
                                                class="p-button-success" (click)="uploadExcel()"
                                                [disabled]="!selectedFile">
                                            </button>

                                        </div>
                                        <button pButton type="button" label="Search" icon="pi pi-search"
                                            class="p-button-success ml-2" (click)="onSearchClick()"
                                            [disabled]="!selectedFile">
                                        </button>

                                    </div>
                                </div>
                                <p-iconField>
                                    <input pInputText type="text" #searchInput
                                        (input)="onFilterGlobal($event.target.value)" placeholder="Search keyword"
                                        [(ngModel)]="searchValues" />
                                    <button *ngIf="isEditMode" pButton icon="pi pi-plus"
                                        (click)="addRowBelow(searchInput)" class="add-button ml-2"
                                        pTooltip="Add Row"></button>
                                </p-iconField>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>

                                <th *ngFor="let header of tableHeaders"
                                    [ngStyle]="isEditMode ? getColStyle(header) : {}">
                                    {{ header }}
                                    <input type="text" placeholder="Filter" [(ngModel)]="headerFilters[header]" />
                                </th>
                                <th *ngIf="isEditMode" style="width:70px; max-width:70px; text-align:center;">
                                    Actions
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let header of tableHeaders"
                                    [ngStyle]="isEditMode ? getColStyle(header) : {}">
                                    <ng-container
                                        *ngIf="isEditMode && (header !== 'Prepared By' && header !== 'Approved By') ; else readOnlyCell">
                                        <ng-container
                                            *ngIf="isPatentTypeMaster() && isPatentFocus(header); else normalInput">
                                            <textarea [(ngModel)]="rowData[header]"
                                                class="editable-cell patent-focus-textarea" rows="3"></textarea>
                                        </ng-container>

                                        <ng-template #normalInput>
                                            <input type="text" [(ngModel)]="rowData[header]" class="editable-cell" />
                                        </ng-template>

                                    </ng-container>
                                    <ng-template #readOnlyCell>
                                        {{ rowData[header] }}
                                    </ng-template>
                                </td>
                                <td *ngIf="isEditMode"
                                    style="width:70px; max-width:70px; text-align:center; white-space:nowrap;">
                                    <button pButton *ngIf="rowData?.newrow" (click)="saveRowData(rowData,rowIndex)"
                                        class="add-button" pTooltip="Save Row">Save</button>

                                    <button pButton icon="pi pi-trash" (click)="deleteRow(rowData,rowIndex)"
                                        class="delete-button ml-2" pTooltip="Delete Row"></button>
                                </td>

                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </ng-container>
</div>